module.exports = __webpack_public_path__ + "static/media/hapicolibri.8baada0e.jpg";